export enum CmpConfigPublisherCustomPurposeField {
    ID = "id",
    NAME = "name",
    DESCRIPTION = "description",
    LEGAL_BASIS = "legalBasis",
    VENDOR = "vendor",
    TRANSLATIONS = "translations"
}
